import React from 'react';

import { Footer } from '../../components/layout/footer';
import { RedirectHeader } from '../../components/layout/redirect-header';
import useAuth from '../../hooks/utils/useAuth';

const PwaRedirectPage = (): JSX.Element => {
  const { logout } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <RedirectHeader />
      <main className="flex flex-1 items-center">
        <div className="max-w-page mx-auto flex w-full items-center justify-center px-6">
          <div className="flex max-w-xl flex-col items-center gap-8 text-center">
            <div className="space-y-4">
              <p className="font-albert-sans text-2xl font-semibold leading-7 text-black md:text-[28px]">
                It appears you are a peer trying to login as a member.
              </p>
              <p className="font-open-sans text-body-gray text-base leading-6 md:text-lg">
                Please click the button below to be redirected to our peer web app.
              </p>
            </div>

            <a href={process.env.REACT_APP_LISTENER_LINK}>
              <button
                type="button"
                className="font-open-sans bg-button-primary hover:bg-button-primary-hover inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-10 py-2.5 text-base font-medium leading-5 text-white transition-colors"
              >
                Peer Web App
              </button>
            </a>

            <div className="mt-4 flex flex-col items-center gap-3 text-sm">
              <p className="font-open-sans text-body-gray max-w-md pb-2 text-center font-normal leading-snug">
                Would you like to sign up or login as a member?
              </p>
              <button
                type="button"
                data-testid="login-button"
                className="font-albert-sans text-primary flex items-center font-semibold leading-tight hover:opacity-80"
                onClick={logout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PwaRedirectPage;
